export var DateTimeType;
(function (DateTimeType) {
    DateTimeType["DATE"] = "date";
    DateTimeType["WEEK"] = "week";
    DateTimeType["MONTH"] = "month";
    DateTimeType["YEAR"] = "year";
    DateTimeType["TIME"] = "time";
    DateTimeType["QUARTER"] = "quarter";
})(DateTimeType || (DateTimeType = {}));
